// src/components/forms/FormTextArea.jsx
import React from 'react';

export const FormTextArea = ({
  label,
  error,
  required,
  className = '',
  rows = 4,
  ...props
}) => {
  return (
    <div className="form-control">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <textarea
        rows={rows}
        className={`
          block w-full rounded-md shadow-sm
          ${error ? 'border-red-300 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-uzima-maroon-400 focus:border-uzima-maroon-400'}
          disabled:bg-gray-50 disabled:text-gray-500
          sm:text-sm
          ${className}
        `}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};